import NoConnectionSetup from './NoConnectionSetup';
import EnablingFeature from '../../../../components/EnablingFeature';
import { Backdrop } from '@mui/material';
import { LoadingCircles } from '../../../../components/icons';
import { useTreasuryAccounts } from '../../../../customhooks/treasury/useTreasuryAccounts';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useEffect, useState } from 'react';
import TreasurySplashScreen from './TreasurySplashScreen';
import { toast } from 'react-toastify';

const TreasuryManagement = () => {
    const { accounts, isLoadingAccounts } = useTreasuryAccounts();
    const userId = useSelector((state: RootState) => state.user.user?.user_id);

    const [showSplash, setShowSplash] = useState(false);
    const [loadingSplash, setLoadingSplash] = useState(false);

    useEffect(() => {
        if (!isLoadingAccounts && userId && !accounts.length) {
            const splashKey = `splashSeen-${userId}`;
            const hasSeenSplash = localStorage.getItem(splashKey);
            if (!hasSeenSplash) {
                setShowSplash(true);
            }
        } else {
            setShowSplash(false);
        }
    }, [isLoadingAccounts, userId, accounts.length]);

    const handleDismissSplash = () => {
        if (userId) {
            localStorage.setItem(`splashSeen-${userId}`, 'true');
        }
        setLoadingSplash(true);

        setTimeout(() => {
            setShowSplash(false);
            setLoadingSplash(false);
            toast.success(
                "Access request submitted successfully. You'll be notified when reviewed."
            );
        }, 3000);
    };

    return (
        <div>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                open={isLoadingAccounts}
            >
                <div className='animate-spin'>
                    <LoadingCircles />
                </div>
            </Backdrop>
            <EnablingFeature flag='Accessible'>
                {showSplash ? (
                    <TreasurySplashScreen onContinue={handleDismissSplash} loading={loadingSplash}/>
                ) : !accounts?.length ? (
                    <NoConnectionSetup />
                ) : (
                    <Outlet />
                )}
            </EnablingFeature>
        </div>
    );
};

export default TreasuryManagement;
